import React from 'react'
import styles from './styles.module.scss'

function FooterPure({
  level,
  isModal,
  totalResponseCount,
  moreCommentLabel,
  renderTotalResponseIcon,
  renderReactionContainer,
  openPostModal,
  renderReplyButton
}) {
  return (
    <div className={`${styles.footer} ${level > 1 && styles.footerInComment}`}>
      <div className={styles.leftActions}>{renderReactionContainer && renderReactionContainer()}</div>
      {/* For parent feed */}
      {level === 1 && (
        <button
          aria-label={moreCommentLabel}
          {...(!isModal ? { onClick: openPostModal } : {})}
          className={`${styles.commentsButton} ${totalResponseCount > 0 && styles.commentGreenButton}`}>
          {totalResponseCount > 0 && <span className={`${styles.commentCountGreen} `}>{totalResponseCount}</span>}
          {renderTotalResponseIcon()}
        </button>
      )}
      {/* For parent comments and replies */}
      {renderReplyButton && renderReplyButton()}
    </div>
  )
}

export default FooterPure
